<template>
  <div class="feature-title">
      <div class="title text-center py-1 text-upercase">
          COLUMN
      </div>
  </div>
</template>

<script>
export default {
  name: "FeatureTittle"
};
</script>

<style lang="less">
.feature-title {
  .title {
    width: 100%;
    font-size: 0.7rem;
    font-family: FranklinGothic-Demi;
    color: #333333;
    font-weight: bolder;
  }
}
</style>